<template>
  <div class="compareListOffer">
    <div class="compareListOffer__descriptionWrapper">
      <div class="compareListOffer__fukidashiWrapper">
        <p class="compareListOffer__fukidashi">学校の主要情報が簡単に比較できる！</p>
      </div>
      <img src="/images/s/dot_left.png" class="compareListOffer__dotImg" />
      <p class="compareListOffer__description__text">
        会員限定の新機<span class="compareListOffer__description--letter7">能</span> <br class="break332" /><span
          class="compareListOffer__description__colorText"
          >「学校比較<span class="compareListOffer__description--letter6">」</span></span
        >
      </p>
      <img src="/images/s/dot_right.png" class="compareListOffer__dotImg" />
    </div>
    <img src="/images/s/gakko_compare.png" class="compareListOffer__img" />
    <div class="compareListOffer__loginBtnWrapper">
      <a class="compareListOffer__loginBtn" :href="compareLink" @click="$emit('click-go-compare', $event)"
        >比較機能を使ってみる</a
      >
    </div>
    <p class="compareList__description">※比較機能はスマートフォンでのご利用を推奨しています。</p>
  </div>
</template>

<script>
export default {
  name: 'CompareOfferPc',
  props: {
    compareLink: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.compareListOffer__img {
  display: block;
  width: 100%;
  aspect-ratio: 1.63 / 1;
}

.compareListOffer__descriptionWrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  color: #24243f;
}

.compareListOffer__dotImg {
  width: 18px;
  height: 24px;
}

.compareListOffer__description__text {
  padding: 0 8px;
  text-align: center;
}

.compareListOffer__description--letter6 {
  letter-spacing: -6px;
}

.compareListOffer__description--letter7 {
  letter-spacing: -7px;
}

.compareListOffer__description__colorText {
  font-size: 20px;
  color: #de30ca;
}

.break332 {
  display: none;
}

@media (max-width: 332px) {
  .break332 {
    display: block;
  }
}

.compareListOffer__loginBtnWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.compareListOffer__loginBtn {
  display: block;
  border-radius: 4px;
  border: 1px solid #0ca5e6;
  color: #0ca5e6;
  background-color: #fff;
  padding: 11px 12px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  width: 360px;
  box-sizing: border-box;
  line-height: 1;
}

.compareListOffer__wrapper {
  width: 424px;
}

.compareListOffer {
  width: 424px;
  margin: 45px auto 32px;
  padding: 25px 40px 32px;
  background-color: #e7f6ff;
}

.compareList__description {
  margin-top: 8px;
  color: #808d96;
  font-size: 12px;
  line-height: 1.5;
}

.compareListOffer__fukidashi {
  position: relative;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.6;
  text-align: center;
  color: #fff;
  padding: 4px 12px;
}

.compareListOffer__fukidashi::before {
  content: '';
  position: absolute;
  bottom: -9px;
  left: calc(50% - 5px);
  border: 5px solid transparent;
  border-top: 5px solid #0b41a0;
}

.compareListOffer__fukidashiWrapper {
  position: absolute;
  top: -36px;
  width: fit-content;
  height: 100%;
  margin-inline: auto;
  border-radius: 20px;
  background-color: #0b41a0;
}
</style>
